import React, { useState } from "react";
import PerfectScrollbar from "react-perfect-scrollbar";
import { JSONTree } from "react-json-tree";
import { CopyToClipboard } from "react-copy-to-clipboard";

interface LogModalProps {
  log: any;
  isOpen: boolean;
  onClose: (state: boolean) => void;
  position: { x: number; y: number };
}

const LogModal: React.FC<LogModalProps> = ({ log, isOpen, onClose, position }) => {
  // 창의 너비와 클릭한 위치를 비교하여 왼쪽/오른쪽 중 여유 있는 곳에 모달 띄우기
  const windowWidth = window.innerWidth;
  const windowHeight = window.innerHeight;

  // 여유 공간 비교
  const leftSpace = position.x; // 클릭한 위치의 왼쪽 공간
  const rightSpace = windowWidth - position.x; // 클릭한 위치의 오른쪽 공간
  const topSpace = position.y; // 클릭한 위치의 위쪽 공간
  const bottomSpace = windowHeight - position.y; // 클릭한 위치의 아래쪽 공간
  const [copySuccess, setCopySuccess] = useState(false);

  const handleCopySuccess = () => {
    setCopySuccess(true);

    setTimeout(() => {
      setCopySuccess(false);
    }, 2000);
  };

  // 더 넓은 쪽으로 모달 배치
  const modalWidthStyle =
    rightSpace > leftSpace
      ? { left: `${position.x}px` } // 오른쪽이 넓으면 left 사용
      : { right: `${windowWidth - position.x}px` }; // 왼쪽이 넓으면 right 사용

  const modalHeightStyle =
    bottomSpace > topSpace
      ? { top: `${position.y}px` } // 아래쪽이 넓으면 top 사용
      : { bottom: `${windowHeight - position.y}px` }; // 위쪽이 넓으면 bottom 사용

  if (!isOpen) return null;

  return (
    <div
      className="fixed z-50 w-[46vw] bg-white border border-black rounded-md  shadow-lg"
      style={{
        ...modalHeightStyle,
        ...modalWidthStyle,
      }}
    >
      <PerfectScrollbar
        onClick={(e) => {
          e.stopPropagation();
        }}
      >
        <div
          className="grid grid-cols-6 gap-2 max-h-[40vh]"
          onClick={() => {
            onClose(false);
          }}
        >
          <div className="text-center bg-gray-300 place-content-center">IP</div>
          <div className="place-content-center">{log.ip}</div>
          <div className="text-center bg-gray-300 place-content-center">사용자</div>
          <div className="break-words">{log.adminUsername}</div>
          <div className="text-center bg-gray-300 place-content-center">State</div>
          <div className="place-content-center">{log.statusCode}</div>
          <div className="text-center bg-gray-300 place-content-center">시간</div>
          <div className="col-span-2">{log.requestTime}</div>
          <div className="text-center bg-gray-300 place-content-center">URL</div>
          <div className="col-span-2">{log.requestUrl}</div>
          <div className="text-center bg-gray-300 place-content-center">실행한 기능</div>
          <div className="col-span-5 break-words">{log.apiDescription}</div>
          <div className="text-center bg-gray-300 place-content-center">입력 데이터</div>
          <div
            className="relative col-span-5 break-words"
            onClick={(e) => {
              e.stopPropagation();
            }}
          >
            <div className="absolute z-50 flex top-2 right-2">
              {copySuccess && <p className="mr-2 text-xs text-green-500 place-content-center">✅ 복사 완료!</p>}
              <CopyToClipboard text={log.requestData} onCopy={() => handleCopySuccess()}>
                <button className="px-2 py-1 text-xs text-white bg-blue-500 rounded hover:bg-blue-600 hover:cursor-pointer">
                  복사하기
                </button>
              </CopyToClipboard>
            </div>
            <JSONTree data={JSON.parse(log.requestData)} />
          </div>
          <div className="text-center bg-gray-300 place-content-center">로그 메시지</div>
          <div className="col-span-5 break-words">{log.responseData}</div>
        </div>
      </PerfectScrollbar>
    </div>
  );
};

export default LogModal;
